module.exports = __webpack_public_path__ + "img/camera-video-fill.5a8debb2.svg";